
export default {
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  computed: {
    imageSrc () {
      return this.section.image?.image?.data?.attributes.url.replace(
        /^.*\/\/[^/]+/,
        ''
      )
    }
  }
}
